import {
    Box,
    EmptyState,
    Grid,
    GridProps,
    Heading,
    Text,
    VStack,
} from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import { LuShoppingCart } from 'react-icons/lu';
import { Button } from 'shared';
import { ICartFullItem } from '../../lib/types/cart-full-item';
import { CartItemCard } from './cart-item-card';
import { CartPageOrderModal } from '../modals/cart-page-order-modal';

type CartPageMainProps = {
    cartItems: ICartFullItem[]
} & GridProps & React.RefAttributes<HTMLDivElement>

export const CartPageMain: React.FC<CartPageMainProps> = ({
    cartItems,
    ...props
}) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);

    const totalPrice = useMemo(() => {
        let res = 0;
        cartItems.forEach(({ price }) => {
            if (price) res += price;
        });
        return res;
    }, [JSON.stringify(cartItems)]);

    return (
        <Grid
            {...props}
        >
            <Grid
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                margin="0 auto"
                width="100%"
                padding="2rem"
                gap="2rem"
            >
                <Heading>
                    Корзина
                </Heading>
                {cartItems.length > 0 ? (
                    <Grid
                        templateColumns={{
                            base: '1fr',
                            lg: '2fr auto 1fr',
                        }}
                        gap="2rem"
                    >
                        <Grid gap="0.5rem">
                            {cartItems.map(({
                                type,
                                uid,
                                portionIndex,
                                title,
                                price,
                                image,
                                count,
                                pricePrefix,
                            }) => (
                                <CartItemCard
                                    type={type}
                                    uid={uid}
                                    portionIndex={portionIndex}
                                    title={title}
                                    price={price}
                                    pricePrefix={pricePrefix}
                                    image={image}
                                    currency={{
                                        abbreviation: 'р',
                                    }}
                                    count={count}
                                />
                            ))}
                        </Grid>
                        <Box
                            width={{ base: '100%', lg: '2px' }}
                            height={{ base: '2px', lg: '100%' }}
                            background="#DDDDDD"
                        />
                        <Grid height="fit-content" gap="2rem">
                            <Grid templateColumns="auto 1fr" gap="1rem">
                                <Text fontSize="1.5rem">
                                    Сумма заказа:
                                </Text>
                                <Text fontWeight="bold" fontSize="1.5rem">
                                    {`${totalPrice.toLocaleString()} р`}
                                </Text>
                            </Grid>
                            <Button
                                onClick={handleOpen}
                                fontWeight="bold"
                                background="#E74C3C"
                                disabled={cartItems.length === 0}
                            >
                                Оформить заказ
                            </Button>
                        </Grid>
                    </Grid>
                ) : (
                    <EmptyState.Root size="lg">
                        <EmptyState.Content>
                            <EmptyState.Indicator>
                                <LuShoppingCart />
                            </EmptyState.Indicator>
                            <VStack textAlign="center">
                                <EmptyState.Title>Ваша корзина пуста</EmptyState.Title>
                                <EmptyState.Description>
                                    Добавьте в неё что-нибудь
                                    и тогда мы сможем продолжить
                                </EmptyState.Description>
                            </VStack>
                        </EmptyState.Content>
                    </EmptyState.Root>
                )}
                <CartPageOrderModal
                    cartItems={cartItems}
                    open={open}
                    setOpen={setOpen}
                />
            </Grid>
        </Grid>
    );
};
